import React from 'react'
import { Button } from '@mui/material'
import "./Answers.css"

const Answers = (props) => {
    return (
        <div id="answersDiv">
        <Button variant="contained" className="buttons" value={props.option1} onClick={props.answerCheck}>{props.option1}</Button>
        <Button variant="contained" className="buttons" value={props.option2} onClick={props.answerCheck}>{props.option2}</Button>
        <Button variant="contained" className="buttons" value={props.option3} onClick={props.answerCheck}>{props.option3}</Button>
        <Button variant="contained" className="buttons" value={props.option4} onClick={props.answerCheck}>{props.option4}</Button>
                </div>
        
    )
}

export default Answers
